<template>
    <v-form-element :id="inputId" :label="null" :form="form" :input-name="inputName" :with-counter="withCounter" :max-length="maxLength" :container-class-name="containerClassName" :label-container-class-name="labelContainerClassName" :input-container-class-name="inputContainerClassName" :helper="helper">
        <template v-if="model.length > 0">
            <div class="flex flex-wrap mb-4 -mx-2">
                <div class="w-full md:w-1/2 lg:w-1/3 mb-4 px-2" v-for="(image, index) in model" :key="index">
                    <div class="bg-gray-200 rounded border border-gray-300" @click.prevent="removeImage(index)">
                        <div class="w-full h-32 bg-contain bg-center bg-no-repeat" :style="{'background-image': 'url('+image.source+')'}"></div>
                    </div>
                </div>
            </div>
        </template>
        <v-image-upload-button
            :label-id="labelId"
            :input-id="inputId"
            :loading="loading"
            :multiple="multiple"
            :multiple-values="multipleValues"
            :having-value="havingValue"
            @upload="handleImageUpload"
            ref="imageUploadButton"
        >
            <template slot="text">
                <span>{{ buttonText }}</span>
            </template>
        </v-image-upload-button>
    </v-form-element>
</template>

<script>
    import Loader from './../_Partials/Loader';
    import FormElement from './Element';
    import mixin from './mixin';
    import imageUploadMixin from './image-upload-mixin';
    import ImageUploaderButtonVue from './ImageUploaderButton.vue';

    export default {

        data() {
            return {
                loading: false,
                labelId: null,
                inputId: null
            }
        },

        components: {
            'v-loader': Loader,
            'v-image-upload-button': ImageUploaderButtonVue,
            'v-form-element': FormElement
        },

        mixins: [mixin, imageUploadMixin],

        props: {
            multiple: {
                type: Boolean,
                default: false
            },
            id: {
                type: String,
                required: false
            },
            multipleValues: {
                type: Boolean,
                required: false,
                default: true
            },
            resizeImages: {
                type: Boolean,
                required: false,
                default: false
            }
        },

        methods: {
            async handleImageUpload()
            {
                if ( this.loading ) {
                    return;
                }

                this.load(true);
                const files = Array.from(this.$refs.imageUploadButton.getFiles());
                await Promise.all(files.map(file => this.handleFile(file)));
                this.load(false)
                    .$nextTick(this.successfulUpload)
            },

            async handleFile(file)
            {
                let image;
                if (this.resizeImages) {
                    try { image = await this.getResizedBase64ForImage(file); } 
                    catch ({ message }) {
                        return window.Toasteo.error(message);
                    }
                } else {
                    image = { source: await this.getBase64ForImage(file) }
                }
                
                if (this.multipleValues) {
                    this.model.push(image);
                } else {
                    this.model.splice(0, this.model.length, image);
                }
            },

            load(isLoading)
            {
                this.loading = isLoading;
                this.$emit('load', isLoading);
                
                return this;
            },

            successfulUpload()
            {
                this.$emit('updated', this.model);
                document.getElementById(this.inputId).value = null;
            },

            removeImage(index)
            {
                this.model.splice(index, 1);
                window.Toasteo.success('Image removed.');
            }
        },

        computed: {
            havingValue()
            {
                return this.model.length > 0;
            },
            buttonText()
            {
                return this.havingValue
                    ? this.multipleValues
                        ? this.multiple
                            ? this.$t('form.labels.image_uploader_button_more_multiple')
                            : this.$t('form.labels.image_uploader_button_more')
                        : this.model.length > 1
                            ? this.$t('form.labels.image_uploader_button_replace_multiple')
                            : this.$t('form.labels.image_uploader_button_replace')
                    : this.multiple
                            ? this.$t('form.labels.image_uploader_button_multiple')
                            : this.$t('form.labels.image_uploader_button');
            }
        },

        created() {
            this.labelId = this.randomId();
            this.inputId = this.randomId();
        },

        mounted() {
            
            let label = document.getElementById(this.labelId);
            let input = document.getElementById(this.inputId);
            let vue = this;

            document.addEventListener('dragenter', function (event) {
                if ( event.toElement && event.toElement.id == vue.inputId ) {
                    label.classList.add('shadow-md');
                    label.classList.add('bg-white');
                    label.classList.remove('bg-gray-100');
                }
            }, false);

            document.addEventListener('drop', function (event) {
                if ( event.toElement && event.toElement.id == vue.inputId ) {
                    label.classList.remove('shadow-md');
                    label.classList.remove('bg-white');
                    label.classList.add('bg-gray-100');
                }
            }, false);

            document.addEventListener('dragexit', function (event) {
                if ( event.toElement && event.toElement.id == vue.inputId ) {
                    label.classList.remove('shadow-md');
                    label.classList.remove('bg-white');
                    label.classList.add('bg-gray-100');
                }
            }, false);

            document.addEventListener('dragleave', function (event) {
                if ( event.toElement && event.toElement.id == vue.inputId ) {
                    label.classList.remove('shadow-md');
                    label.classList.remove('bg-white');
                    label.classList.add('bg-gray-100');
                }
            }, false);

            document.addEventListener('dragend', function (event) {
                if ( event.toElement && event.toElement.id == vue.inputId ) {
                    label.classList.remove('shadow-md');
                    label.classList.remove('bg-white');
                    label.classList.add('bg-gray-100');
                }
            }, false);

        }
    }
</script>